import { PageInterface } from "../interfaces";
import FirstAccessPage from "../sections/authentication/FirstAccessPage";
import LoginPage from "../sections/authentication/LoginPage";
import RecoveryPasswordPage from "../sections/authentication/RecoveryPasswordPage";
import ResetPasswordPage from "../sections/authentication/ResetPasswordPage";

export const authenticationPagesList: PageInterface[] = [
  {
    name: "LoginPage",
    pathName: "/login",
    pageElement: LoginPage,
  },
  {
    name: "FirstAccessPage",
    pathName: "/firstaccess",
    pageElement: FirstAccessPage,
  },
  {
    name: "RecoveryPasswordPage",
    pathName: "/recoverypassword",
    pageElement: RecoveryPasswordPage,
  },
  {
    name: "ResetPasswordPage",
    pathName: "/resetpassword",
    pageElement: ResetPasswordPage,
  },
  {
    name: "VerifyEmailPage",
    pathName: "/verify",
    pageElement: ResetPasswordPage,
  },
];
